import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

interface PosContextValue {
  open: boolean;
  openPos: () => void;
  closePos: () => void;
}

const PosContext = createContext<PosContextValue | null>(null);

export function PosProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const openPos = useCallback(() => setOpen(true), []);
  const closePos = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ open, openPos, closePos }), [open, openPos, closePos]);
  return <PosContext.Provider value={value}>{children}</PosContext.Provider>;
}

export function usePos(): PosContextValue {
  const context = useContext(PosContext);
  if (!context) throw new Error('usePos debe usarse dentro de PosProvider');
  return context;
}
